import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Bell,
  ArrowLeftRight,
  Users,
  Settings,
  BarChart3,
  Brain,
  Activity,
  // Copy,
} from "lucide-react";
import type { SidebarNavItem } from "./DesktopLayout.types";

const navItems: Omit<SidebarNavItem, "isActive">[] = [
  {
    id: "alerts",
    label: "Alerts",
    icon: <Bell className="w-5 h-5" />,
    path: "/alerts",
  },
  {
    id: "price-alerts",
    label: "Price Alerts",
    icon: <Activity className="w-5 h-5" />,
    path: "/price-alerts",
  },
  {
    id: "trade",
    label: "Trade",
    icon: <ArrowLeftRight className="w-5 h-5" />,
    path: "/positions",
  },
  // {
  //   id: "copy-trading",
  //   label: "Copy Trading",
  //   icon: <Copy className="w-5 h-5" />,
  //   path: "/copy-trading",
  // },
  {
    id: "analyze",
    label: "Analyze",
    icon: <Brain className="w-5 h-5" />,
    path: "/analyze",
  },
  {
    id: "referrals",
    label: "Referrals",
    icon: <Users className="w-5 h-5" />,
    path: "/referrals",
  },
  {
    id: "statistics",
    label: "Statistics",
    icon: <BarChart3 className="w-5 h-5" />,
    path: "/statistics",
  },
  {
    id: "settings",
    label: "Settings",
    icon: <Settings className="w-5 h-5" />,
    path: "/settings",
  },
];

interface SidebarNavProps {
  /** Optional additional content to render at the bottom of the sidebar */
  bottomContent?: React.ReactNode;
}

export const SidebarNav: React.FC<SidebarNavProps> = ({ bottomContent }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path: string): boolean => {
    return (
      location.pathname === path || location.pathname.startsWith(`${path}/`)
    );
  };

  return (
    <aside className="w-64 bg-secondary border-r border-border flex flex-col h-screen sticky top-0">
      {/* Logo & Brand */}
      <button
        className="p-6 border-b border-border h-[109px]"
        onClick={() => navigate("/")}
      >
        <div className="flex items-center gap-3">
          <img
            src="/logo.svg"
            alt="Trigger"
            className="w-10 h-10"
            onError={(e) => {
              // Fallback if logo doesn't exist
              e.currentTarget.style.display = "none";
            }}
          />
          <span className="text-xl font-bold text-text-primary">Trigger</span>
        </div>
      </button>

      {/* Navigation Links */}
      <nav className="flex-1 p-4">
        <ul className="space-y-1">
          {navItems.map((item) => {
            const active = isActive(item.path);
            return (
              <li key={item.id}>
                <button
                  onClick={() => navigate(item.path)}
                  className={`
                    w-full flex items-center gap-3 px-4 py-3 rounded-xl text-left
                    transition-all duration-200 group
                    ${
                      active
                        ? "bg-accent/10 text-accent border border-accent/30"
                        : "text-text-secondary hover:bg-tertiary hover:text-text-primary border border-transparent"
                    }
                  `}
                >
                  <span
                    className={`${active ? "text-accent" : "text-text-secondary group-hover:text-text-primary"} transition-colors`}
                  >
                    {item.icon}
                  </span>
                  <span className="font-medium">{item.label}</span>
                </button>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Bottom Content (Share Card) */}
      {bottomContent && (
        <div className="p-4 border-t border-border">{bottomContent}</div>
      )}
    </aside>
  );
};
